// @flow

import React, { type Node, createContext, useContext } from 'react';
import { type CardBrand } from '@tectonics/prs/card-brand';

const SelectedCardBrandContext = createContext<?CardBrand>(null);

type SelectedCardBrandProviderProps = {|
  cardBrand: ?CardBrand,
  children: Node,
|};

export function SelectedCardBrandProvider({ cardBrand, children }: SelectedCardBrandProviderProps): Node {
  return (
    <SelectedCardBrandContext.Provider value={cardBrand}>
      {children}
    </SelectedCardBrandContext.Provider>
  );
}

export function useSelectedCardBrand(): ?CardBrand {
  return useContext(SelectedCardBrandContext);
}
